import GenericModal from "../../../utils/GenericModal";
import useUpdateCompanyRestrictionsModal from "../../../hooks/companies/useUpdateCompanyRestrictionsModal";
import React from "react";
import {TernarySwitchComponent} from "../../../utils/FormComponents";
import {LoadingAnimationContainer} from "../../../utils/loading_animation";

export default function UpdateCompanyRestrictionsModal(company) {
    const [
        {configuration, isCompanyRestrictionsLoading, companyQuestionsEnabled, companyDocumentsUploadEnabled},
        {toggleMe, setCompanyQuestionsEnabled, setCompanyDocumentsUploadEnabled, handleSubmit},
    ] = useUpdateCompanyRestrictionsModal(company);

    return <GenericModal exitClick={false} toggleMe={toggleMe} showCloseButton={true}>
        <div className="font-semibold w-full text-left px-4 py-3 border-b text-sm">Modifier les restrictions</div>
        {configuration == null || isCompanyRestrictionsLoading ? <LoadingAnimationContainer/> : (
            <form onSubmit={handleSubmit} noValidate>
                <div className="p-8 flex items-start gap-8 flex-wrap">
                    <TernarySwitchComponent
                        checked={companyQuestionsEnabled}
                        onChange={setCompanyQuestionsEnabled}
                        label="Questions au Chatbot :"
                        checkedLabel="Activées"
                        uncheckedLabel="Désactivées"
                        defaultLabel={`Par défaut (${configuration.questions_enabled ? "activées" : "désactivées"})`}
                    />

                    <TernarySwitchComponent
                        checked={companyDocumentsUploadEnabled}
                        onChange={setCompanyDocumentsUploadEnabled}
                        label="Ajout de documents :"
                        checkedLabel="Activés"
                        uncheckedLabel="Désactivés"
                        defaultLabel={`Par défaut (${configuration.documents_upload_enabled ? "activés" : "désactivés"})`}
                    />
                </div>
                <div className="flex w-full justify-end gap-4 py-2 border-t px-4">
                    <button onClick={toggleMe}
                            className="rounded border bg-white text-black text-sm font-light py-1 px-2">
                        Annuler
                    </button>
                    <button type="submit" className="rounded bg-gray-600 hover:bg-gray-700 hover:shadow text-white text-sm py-1 px-2 transform duration-300">
                        Valider
                    </button>
                </div>
            </form>
        )}
    </GenericModal>;
}